const translations = {
  'pending_transfer': 'Aguardando transferência',
  'transferred': 'Transferido',
  'failed': 'Falhou',
  'canceled': 'Cancelado'
}

const colors = {
  'pending_transfer': 'warning',
  'transferred': 'success',
  'failed': 'danger',
  'canceled': 'secondary'
}

export {translations, colors}
